<div class="nt-aviso" [style.--nt-cor]="visual.cor" [style.--nt-cor-suave]="visual.corSuave"
     role="alert" aria-live="polite">
  <div class="nt-aviso-capa" *ngIf="capaUrl" (click)="ver()">
    <img [src]="capaUrl" alt="">
  </div>
  <div class="nt-aviso-corpo">
    <div class="nt-aviso-topo">
      <span class="nt-aviso-icone"><mat-icon>{{ visual.icone }}</mat-icon></span>
      <span class="nt-aviso-tipo">{{ visual.rotulo }}</span>
      <span class="nt-aviso-nova">Nova</span>
      <span class="nt-aviso-espaco"></span>
      <button class="nt-aviso-x" type="button" (click)="dispensar()" aria-label="Dispensar">
        <mat-icon>close</mat-icon>
      </button>
    </div>
    <div class="nt-aviso-titulo" (click)="ver()">{{ data.notificacao?.titulo }}</div>
    <div class="nt-aviso-resumo" *ngIf="resumo">{{ resumo }}</div>
    <div class="nt-aviso-acoes">
      <span class="nt-aviso-mais" *ngIf="data.restantes > 0">
        +{{ data.restantes }} {{ data.restantes === 1 ? 'nova' : 'novas' }}
      </span>
      <span class="nt-aviso-espaco"></span>
      <button class="nt-aviso-btn-sec" type="button" (click)="dispensar()">Agora não</button>
      <button class="nt-aviso-btn" type="button" (click)="ver()">
        Ver agora<mat-icon>arrow_forward</mat-icon>
      </button>
    </div>
  </div>
</div>
